/**
 * Nulls last, otherwise locale-aware natural comparison - both a finding's
 * `label` and a cartothèque entry's `no` are free-text ("1a", "12", "2b",
 * ...), and a plain string sort would put "10" before "2". localeCompare's
 * own numeric option handles the leading-number case natural sort needs
 * without a custom parser. Shared by ExhibitionPage (findings, by label)
 * and SocietyPage (cartothèque entries, by no).
 */
export default function naturalCompare(a, b) {
  if (!a && !b) return 0;
  if (!a) return 1;
  if (!b) return -1;
  return a.localeCompare(b, undefined, {
    numeric: true,
    sensitivity: 'base'
  });
}
flarum.reg.add('champis-exhibitions', 'forum/utils/naturalCompare', naturalCompare);